import { render, staticRenderFns } from "./m-editBanner.vue?vue&type=template&id=9fc1cce8&"
import script from "./m-editBanner.vue?vue&type=script&lang=js&"
export * from "./m-editBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports